import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface SaveTheDateCardProps {
  username?: string;
}

export const SaveTheDateCard: React.FC<SaveTheDateCardProps> = ({ username }) => {
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        {/* Wingo Wednesday image - taller to show full Daisy */}
        <div className="flex justify-center mb-2 md:mb-3">
          <div className="relative" style={{ width: 'fit-content', maxWidth: '100%' }}>
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse rounded-2xl"></div>
            <img
              src="/wingo-wednesday.jpg"
              alt="Wingo Wednesday"
              className="relative rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ 
                maxHeight: '320px',
                maxWidth: '100%',
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                display: 'block'
              }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
        
        {/* Combined date and button in one compact section */}
        <div className="space-y-2">
          <div className="bg-black/60 backdrop-blur-md rounded-xl p-3 md:p-4 border-2 border-yellow-400/50 shadow-2xl">
            <p className="text-xl md:text-2xl font-bold text-yellow-200 text-center">
              Save the Date: 3/19/2025
            </p>
          </div>
          
          <a
            href="https://www.instagram.com/320trackclub"
            target="_blank"
            rel="noopener noreferrer"
            data-no-navigate="true"
            className="block text-center relative z-50"
            style={{ pointerEvents: 'auto', touchAction: 'manipulation' }}
            onClick={(e) => {
              e.stopPropagation();
              window.open('https://www.instagram.com/320trackclub', '_blank', 'noopener,noreferrer');
            }}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchEnd={(e) => {
              e.stopPropagation();
              window.open('https://www.instagram.com/320trackclub', '_blank', 'noopener,noreferrer');
            }}
          >
            <div className="bg-yellow-500/20 backdrop-blur-sm rounded-xl p-2 md:p-3 border-2 border-yellow-400/50 hover:bg-yellow-500/30 transition-colors">
              <p className="text-sm md:text-base text-yellow-200 font-bold">
                Follow Coach DAISY for updates
              </p>
            </div>
          </a>
        </div>
      </div>
    </WrappedCard>
  );
};

